import { useEffect } from "react";

/**
 * Zamyka popover/tooltip kiedy użytkownik zacznie scrollować.
 * Słucha na window i wszystkich scrollowalnych przodkach (capture).
 */
export const useCloseOnScroll = (open: boolean, onClose: () => void) => {
  useEffect(() => {
    if (!open) return;
    const handler = () => onClose();
    window.addEventListener("scroll", handler, { capture: true, passive: true });
    window.addEventListener("touchmove", handler, { capture: true, passive: true });
    return () => {
      window.removeEventListener("scroll", handler, { capture: true } as EventListenerOptions);
      window.removeEventListener("touchmove", handler, { capture: true } as EventListenerOptions);
    };
  }, [open, onClose]);
};
